import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diffusion-card',
  templateUrl: './diffusion-card.component.html',
  styleUrls: ['./diffusion-card.component.scss']
})
export class DiffusionCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
